import apiClient from './apiClient';

const settingsService = {
  // Hotel operational settings
  getSettings: () => apiClient.get('/v1/settings'),
  updateSettings: (data) => apiClient.put('/v1/settings', data),

  // Currency
  getCurrency: () => apiClient.get('/v1/settings/currency'),
  updateCurrency: (data) => apiClient.put('/v1/settings/currency', data),

  // Folio/Invoice numbering sequences
  getSequences: () => apiClient.get('/v1/settings/sequences'),
  updateSequences: (data) => apiClient.put('/v1/settings/sequences', data),

  // Tape-chart room-type groups (named bands above room types on the
  // tape chart; membership managed from the group side via roomTypeIds)
  getRoomTypeGroups: () => apiClient.get('/v1/room-type-groups/'),
  createRoomTypeGroup: (data) => apiClient.post('/v1/room-type-groups/', data),
  updateRoomTypeGroup: (id, data) => apiClient.put(`/v1/room-type-groups/${id}/`, data),
  deleteRoomTypeGroup: (id) => apiClient.del(`/v1/room-type-groups/${id}/`),
  reorderRoomTypeGroups: (orderedIds) => apiClient.post('/v1/room-type-groups/reorder/', { group_ids: orderedIds }),

  // Communications hold (onboarding mode) — see core/email_guard.py
  getCommunicationsHold: () => apiClient.get('/v1/settings/communications-hold'),
  updateCommunicationsHold: (data) => apiClient.put('/v1/settings/communications-hold', data),
  getHeldMessages: (limit = 50) => apiClient.get('/v1/settings/communications-hold/held', { limit }),
};

export default settingsService;
